<template>
  <div>
    <!--
    <div class="row">
      <div class="col my-auto fw-bold">
        Presentation code
      </div>
      <div class="col-3">
        <button class="btn"
                v-bind:class="sortField === 'presentation_code' && sortOrder === 'asc' ?'btn-success' : 'btn-outline-primary'"
                v-on:click="setSorting('presentation_code', 'asc')">
          <icon :icon="['fad', 'arrow-down-a-z']" class="fa-2x my-auto"/>
        </button>
      </div>
      <div class="col-3">
        <button class="btn"
                v-bind:class="sortField === 'presentation_code' && sortOrder === 'desc' ?'btn-success' : 'btn-outline-primary'"
                v-on:click="setSorting('presentation_code', 'desc')">
          <icon :icon="['fad', 'arrow-up-a-z']" class="fa-2x my-auto"/>
        </button>
      </div>
    </div>
    -->
    <div class="row">
      <div class="col my-auto fw-bold">
        Abstract ID
      </div>
      <div class="col-3">
        <button class="btn"
                v-bind:class="sortField === 'abstract_id' && sortOrder === 'asc' ?'btn-success' : 'btn-outline-primary'"
                v-on:click="setSorting('abstract_id', 'asc')">
          <icon :icon="['fad', 'arrow-down-a-z']" class="fa-2x my-auto"/>
        </button>
      </div>
      <div class="col-3">
        <button class="btn"
                v-bind:class="sortField === 'abstract_id' && sortOrder === 'desc' ?'btn-success' : 'btn-outline-primary'"
                v-on:click="setSorting('abstract_id', 'desc')">
          <icon :icon="['fad', 'arrow-up-a-z']" class="fa-2x my-auto"/>
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col my-auto fw-bold">
        Title
      </div>
      <div class="col-3">
        <button class="btn"
                v-bind:class="sortField === 'title' && sortOrder === 'asc' ?'btn-success' : 'btn-outline-primary'"
                v-on:click="setSorting('title', 'asc')">
          <icon :icon="['fad', 'arrow-down-a-z']" class="fa-2x my-auto"/>
        </button>
      </div>
      <div class="col-3">
        <button class="btn"
                v-bind:class="sortField === 'title' && sortOrder === 'desc' ?'btn-success' : 'btn-outline-primary'"
                v-on:click="setSorting('title', 'desc')">
          <icon :icon="['fad', 'arrow-up-a-z']" class="fa-2x my-auto"/>
        </button>
      </div>
    </div>
    <!--    <div class="row mt-3">-->
    <!--      <div class="col my-auto fw-bold">-->
    <!--        Rating-->
    <!--      </div>-->
    <!--      <div class="col-3">-->
    <!--        <button class="btn" v-bind:class="sortField === 'presentation_code' && sortOrder === 'asc' ?'btn-success' : 'btn-outline-primary'">-->
    <!--          <icon :icon="['fad', 'arrow-down-a-z']" class="fa-2x my-auto"/>-->
    <!--        </button>-->
    <!--      </div>-->
    <!--      <div class="col-3">-->
    <!--        <button class="btn" v-bind:class="sortField === 'presentation_code' && sortOrder === 'asc' ?'btn-success' : 'btn-outline-primary'">-->
    <!--          <icon :icon="['fad', 'arrow-down-z-a']" class="fa-2x my-auto"/>-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: 'PosterSort',
  computed: {
    ...mapState('sort', ['sortField', 'sortOrder']),
  },
  methods: {
    ...mapMutations('sort', ['setSortOrder', 'setSortField']),
    setSorting(field, order) {
      this.setSortField(field);
      this.setSortOrder(order);
    }
  }
}
</script>
